import Hero from "@/components/sections/Hero";
import Stats from "@/components/sections/Stats";
import CategoriesGrid from "@/components/sections/CategoriesGrid";
import WhyUs from "@/components/sections/WhyUs";
import IndustryMarquee from "@/components/sections/IndustryMarquee";
import HowItWorks from "@/components/sections/HowItWorks";
import Testimonials from "@/components/sections/Testimonials";
import FAQ from "@/components/sections/FAQ";
import FinalCTA from "@/components/sections/FinalCTA";
import ScrollPopup from "@/components/ScrollPopup";
import { useSeo } from "@/lib/seo";
import { FAQS } from "@/data/site";

export default function Home() {
  useSeo({
    title: "Datorra India — GST Data Provider India | B2B Leads Database & Data Provider Company",
    description:
      "India's trusted pan india b2b database provider — verified GST sales purchase data, company database with GST number, B2B leads database india, real estate, stock market, loan and telecalling databases. Call +91 85379 42196.",
    path: "/",
    jsonLd: [
      {
        id: "home-faq",
        data: {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: FAQS.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        },
      },
      {
        id: "home-service",
        data: {
          "@context": "https://schema.org",
          "@type": "Service",
          serviceType: "Business Database & Data Provider",
          provider: { "@type": "Organization", name: "Datorra India", url: "https://datorra.in" },
          areaServed: { "@type": "Country", name: "India" },
          audience: { "@type": "BusinessAudience", audienceType: "B2B growth teams, agencies, enterprises" },
          hasOfferCatalog: {
            "@type": "OfferCatalog",
            name: "Databases",
            itemListElement: [
              "Business Database",
              "Newly Registered Company Database",
              "GST Database",
              "GST Sales & Purchase Data",
              "B2B & B2C Database",
              "E-Commerce Sellers & Buyers",
              "Doctors Database",
              "Real Estate Database",
              "Stock Market Traders Database",
              "Loan Database",
              "Insurance Database",
              "Import Export Database",
              "Vehicle Owner Database",
              "Mobile Number Database",
              "Telecalling Database",
            ].map((n) => ({
              "@type": "Offer",
              itemOffered: { "@type": "Service", name: n },
            })),
          },
        },
      },
    ],
  });

  return (
    <div data-testid="home-page">
      <Hero />
      <Stats />
      <CategoriesGrid />
      <WhyUs />
      <IndustryMarquee />
      <HowItWorks />
      <Testimonials />
      <FAQ />
      <FinalCTA />
      <ScrollPopup />
    </div>
  );
}
